import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Link, useLocation } from "react-router-dom";
import { Container, Button } from "@material-ui/core";
import { useAuth0 } from "./react-auth0-spa";
import Streaming from "./pages/AdminCategories/Streaming";
import AdminCategories from "./pages/AdminCategories/AdminCategories";
import Countries from "./pages/AdminCategories/Countries";
import Headcategories from "./pages/AdminCategories/HeadCategories";
import TopHeadcategories from "./pages/AdminCategories/TopHeadCategories";
import Bulk from "./pages/AdminCategories/Bulk";
import Roles from "./pages/AdminCategories/Roles";
import FrontPage, { FrontPageHeader } from "./pages/FrontPage/FrontPage";
import Me from "./pages/Me/Me";
import StreamingOverview from "./pages/Streaming/Overview";
import StreamingSingle from "./pages/Streaming/Single";
import FAQ from "./pages/faq";
import Links from "./pages/links";
import Reports from "./pages/Reports/reports";
import DownloadLog from "./pages/downloadlog";
import { GraphsLauncher } from "./pages/Graphs/GraphsLauncher";
import MetabaseDashboard from "./components/metabasedashboard/MetabaseDashboard";
import AccessAnalytics from "./components/accessanalytics/AccessAnalytics";
import ContentDashboard from "./components/contentdashboard/ContentDashboard";
import { useHistory, RouteComponentProps } from "react-router-dom";
import NordicDashboard from "./components/nordicdashboard/NordicDashboard";
import SportsAnalysis from "./components/sportsdashboard/SportsAnalysis";



const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const ProtectedRoute: React.FC<{
  path: string;
  exact?: boolean;
  children: React.ReactNode;
}> = ({ children, ...rest }) => {
  const { isAuthenticated, user, loginWithRedirect, isLoading } = useAuth0();
  const history = useHistory();

  const roles =
    (user?.["https://mediavision.se/roles"] as { name: string }[]) || [];
  const isTvStreamRole = roles.some((r) => r.name === "TV & Streaming Basic");
  const isTvAnalyticsRole = roles.some(
    (r) => r.name === "TV & Streaming - Analytics"
  );
  const isContentRole = roles.some(
    (r) => r.name === "Content Insights - Sweden Analytics"
  );
  const isNordicRole = roles.some(
    (r) => r.name === "Nordic TV & Streaming"
  );

  const isSportsRole = roles.some(
    (r) => r.name === "Nordic - Sport Analysis"
  );

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      loginWithRedirect({
        appState: { targetUrl: window.location.pathname },
      });
      return;
    }

    if (
      !isTvStreamRole &&
      window.location.href.includes("metabase-dashboard")
    ) {
      history.push("/");
      return;
    }
    if (
      !isTvAnalyticsRole &&
      window.location.href.includes("access-analytics")
    ) {
      history.push("/");
      return;
    }
    if (!isContentRole && window.location.href.includes("content-dashboard")) {
      history.push("/");
      return;
    }
    if (!isNordicRole && window.location.href.includes("nordic")) {
      history.push("/");
      return;
    }
     if (!isSportsRole && window.location.href.includes("sports-analysis")) {
      history.push("/");
      return;
    }
  }, [
    isAuthenticated,
    isTvStreamRole,
    isLoading,
    loginWithRedirect,
    history,
    isTvAnalyticsRole,
    isContentRole,
    isNordicRole
  ]);

  const renderFn = ({ location }: RouteComponentProps) => {
    if (isLoading) {
      return (
        <Container maxWidth="sm">
          <p>Loading...</p>
        </Container>
      );
    }

    // if (!isAuthenticated || !isTvStreamRole) {
    //   return null;
    // }
    return <>{children}</>;
  };

  return <Route {...rest} render={renderFn} />;
};

const RouterWithRoutes: React.FC = (props) => {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route exact path="/">
          <FrontPageHeader />
          <FrontPage />
        </Route>
        <Route exact path="/faq">
          <FrontPageHeader />
          <FAQ />
        </Route>
        <Route exact path="/data">
          <FrontPageHeader />
          <GraphsLauncher />
        </Route>
        <Route exact path="/me">
          <FrontPageHeader />
          <Me />
        </Route>
        <Route exact path="/admin/categories">
          <FrontPageHeader />
          <AdminCategories />
        </Route>
        <Route exact path="/admin/categories/:id">
          <FrontPageHeader />
          <AdminCategories />
        </Route>
        <Route exact path="/admin/countries">
          <FrontPageHeader />
          <Countries />
        </Route>
        <Route exact path="/admin/headcategories">
          <FrontPageHeader />
          <Headcategories />
        </Route>
        <Route exact path="/admin/topheadcategories">
          <FrontPageHeader />
          <TopHeadcategories />
        </Route>
        <Route exact path="/admin/roles">
          <FrontPageHeader />
          <Roles />
        </Route>
        <Route exact path="/admin/reports">
          <FrontPageHeader />
          <Reports />
        </Route>
        <Route exact path="/streaming">
          <FrontPageHeader />
          <StreamingOverview />
        </Route>
        <Route exact path="/stream/:id">
          <FrontPageHeader />
          <StreamingSingle />
        </Route>
        <Route exact path="/admin/streaming">
          <FrontPageHeader />
          <Streaming />
        </Route>
        <Route exact path="/admin/bulk">
          <FrontPageHeader />
          <Bulk />
        </Route>
        <Route exact path="/admin/links">
          <FrontPageHeader />
          <Links />
        </Route>
        <Route exact path="/admin/download-log">
          <FrontPageHeader />
          <DownloadLog />
        </Route>
        <ProtectedRoute exact path="/access-analytics">
          <FrontPageHeader />
          <AccessAnalytics />
        </ProtectedRoute>

        <ProtectedRoute exact path="/metabase-dashboard">
          <FrontPageHeader />
          <MetabaseDashboard />
        </ProtectedRoute>
        <ProtectedRoute exact path="/content-dashboard">
          <FrontPageHeader />
          <ContentDashboard />
        </ProtectedRoute>
        <ProtectedRoute exact path="/sports-analysis">
          <FrontPageHeader />
          <SportsAnalysis />
        </ProtectedRoute>
        <Route path="/nordic">
          <FrontPageHeader />
          <NordicDashboard />
        </Route>
        <Route path="*">
          <FrontPageHeader />
          <Container maxWidth="xs">
            <h1>404</h1>
            <p>
              Åh nej, sidan kunde inte hittas. Sidan kan ha funnits och tagits
              bort, eller så kan du ha klickat på en felaktig länk
            </p>
            <Button variant="outlined" color="primary">
              <Link to={"/"} style={{ textDecoration: "none" }}>
                Gå hem
              </Link>
            </Button>
          </Container>
        </Route>
      </Switch>
    </Router>
  );
};

export default RouterWithRoutes;
